import axios from 'axios'
import store from '../store'

export const setCookie = (name, value, days = 365) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export const HTTP = axios.create({
  baseURL: `https://www.macinstore.fr/crm-api/api/`
})

export const secureGet = (url) => {
  return  new Promise((resolve, reject) => {
    HTTP.get(url,{
      auth: {
        username: store.state.User.login,
        password: store.state.User.password
      }
    })
    .then((response) => { resolve(response) })
    .catch((error) => { reject(error.response.data) })
  })
}

export const securePost = (url,obj) => {
  return  new Promise((resolve, reject) => {
    HTTP.post(url,obj,{
      auth: {
        username: store.state.User.login,
        password: store.state.User.password
      }
    })
    .then((response) => { resolve(response) })
    .catch((error) => { reject(error.response.data) })
  })
}

export const securePut = (url,obj) => {
  return  new Promise((resolve, reject) => {
    HTTP.put(url,obj,{
      auth: {
        username: store.state.User.login,
        password: store.state.User.password
      }
    })
    .then((response) => { resolve(response) })
    .catch((error) => { reject(error.response.data) })
  })
}

export const secureDelete = (url) => {
  return  new Promise((resolve, reject) => {
    HTTP.delete(url,{
      auth: {
        username: store.state.User.login,
        password: store.state.User.password
      }
    })
    .then((response) => { resolve(response) })
    .catch((error) => { reject(error.response.data) })
  })
}

export const logInUser = (user) => {
  return HTTP.get('/login',{
    auth: {
      username: user.login,
      password: user.password
    }
  })
}

export const getPec = (id) => {
  return secureGet('/pec/'+id)
}

export const addPec = (obj) => {
  return securePost('/pecs',obj)
}

export const updatePec = (id,obj) => {
  return securePut('/pecs/'+id,obj)
}

export const deletePec = (id) => {
  return secureDelete('/pecs/'+id)
}


export const getHisto = (id) => {
  return secureGet('/pec_histo/'+id)
}

export const addHisto = (obj) => {
  return securePost('/pec_histo',obj)
}

export const updateHisto = (obj) => {
  return securePut('/pec_histo/'+obj.id,obj)
}

export const deleteHisto = (id) => {
  return secureDelete('/pec_histo/'+id)
}



export const getAllStatus = () => {
  return secureGet('/status?order=ordre,asc')
}

export const getStatus = (id) => {
  return secureGet('/status/'+id)
}

export const addStatus = (obj) => {
  return securePost('/status',obj)
}

export const updateStatus = (id,obj) => {
  return securePut('/status/'+id,obj)
}

export const deleteStatus = (id) => {
  return secureDelete('/status/'+id)
}



export const getAllModeles = () => {
  return secureGet('/modeles?order=nom,asc')
}

export const getModeles = (id) => {
  return secureGet('/modeles/'+id)
}

export const addModele = (obj) => {
  return securePost('/modeles',obj)
}

export const updateModele = (id,obj) => {
  return securePut('/modeles/'+id,obj)
}

export const deleteModele = (id) => {
  return secureDelete('/modeles/'+id)
}


export const getAllUsers = () => {
  return secureGet('/users?order=login,asc')
}

export const getUsers = (id) => {
  return secureGet('/users/'+id)
}

export const addUsers = (obj) => {
  return securePost('/users',obj)
}

export const updateUsers = (id,obj) => {
  return securePut('/users/'+id,obj)
}

export const deleteUsers = (id) => {
  return secureDelete('/users/'+id)
}


export const getReparationTypes = (id) => {
  return secureGet('/reparation_types/'+id)
}

export const addReparationTypes = (obj) => {
  return securePost('/reparation_types',obj)
}

export const updateReparationTypes = (id,obj) => {
  return securePut('/reparation_types/'+id,obj)
}

export const deleteReparationTypes = (id) => {
  return secureDelete('/reparation_types/'+id)
}


export const syncModeles = () => {
  return secureGet('/sync/modeles')
}

export const syncClients = () => {
  return secureGet('/sync/customers')
}

export const getHiboutikClientByEmail = (email) => {
  return secureGet('/hiboutik/customers/'+email)
}

export const addHiboutikSale = (client_email) => {
  return securePost('/hiboutik/sale',{ 'client_email': client_email})
}

export const addHiboutikClient = (obj) => {
  return securePost('/hiboutik/customers',obj)
}

export const checkHiboutikClient = (email) => {
  return secureGet('/hiboutik/customers/'+email+'/check')
}

export const searchZipCode = (search, page, limit) => {
  return secureGet('/postalCode/'+search+'?page='+page+','+limit)
}

export const addAttachment = (id,formData) => {
  return securePost('/pecs/'+id+'/attachments',formData,{
    headers: {
        'Content-Type': 'multipart/form-data'
    }
  })
}

export const removeAttachment = (id,attachment_name) => {
  return secureDelete('/pecs/'+id+'/attachments/'+attachment_name)
}